import * as types from "./types";


export const toggleSidebar = (params = {}) => dispatch => {
  
            dispatch({ type: types.TOGLLE_SIDEBAR, payload: params })
           
       
}

export const settingtoggleSidebar = (params = {}) => dispatch => {
  
    dispatch({ type: types.SETTING_TOGLE_SIDEBAR, payload: params })
   

}

export const rewardtoggleSidebar = (params = {}) => dispatch => {
  
    dispatch({ type: types.REWARD_TOGLE_SIDEBAR, payload: params })
   

}

export const managementtoggleSidebar = (params = {}) => dispatch => {
  
    dispatch({ type: types.MANAGEMENT_TOGLE_SIDEBAR, payload: params })
    
}